import script from "./editDocumentFieldPreferencePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./editDocumentFieldPreferencePanel.vue?vue&type=script&setup=true&lang=ts"

import "./editDocumentFieldPreferencePanel.vue?vue&type=style&index=0&id=d5f4f79e&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5f4f79e"]])

export default __exports__